function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "type", "color", "className", "disabled"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from "react";
import classNamesMaker from "classnames";
import styles from "./tag.module.css";
export var TAG_TYPES = {
  OUTLINED: "outlined",
  FILLED: "filled"
};
export var TAG_COLORS = {
  PINK: "pink",
  CYAN: "cyan",
  PURPLE: "purple",
  YELLOW: "yellow",
  MAGENTA: "magenta",
  GREEN: "green",
  ORANGE: "orange",
  RED: "red"
};
var DEPRECATED_TAG_MESSAGE = "\nThe Tag component has been deprecated since 2023-04-21.\n\nReplace it by:\n  \u2022 [For ui-jobteaser]\n    import { Tag } from \"@jobteaser/ui-kit\"\n    \n  \u2022 [For next-jobteaser]\n    import { Tag } from \"@jobteaser/ui-kit/Tag/Tag\"\ninstead.\nMore usage info in https://storybook.jobteaser.com/?path=/docs/stories-tag-tag--default\n".trim();

/**
 * @deprecated The Tag component has been deprecated since 2023-04-21.
 *   Replace it by
 *   for ui-jobteaser:
 *   `import { Tag } from "@jobteaser/ui-kit"`
 *   for next-jobteaser: [Soon available]
 *   `import { Tag } from "@jobteaser/ui-kit/Tag/Tag"`
 *   instead.
 */
export var Tag = function Tag(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TAG_TYPES.OUTLINED : _ref$type,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? null : _ref$color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var customClassNames = classNamesMaker(styles["jds-Tag"], styles["jds-Tag--".concat(type)], _defineProperty({}, styles["jds-Tag--".concat(color)], !!color && !disabled && type === TAG_TYPES.FILLED), _defineProperty({}, styles["jds-Tag--disabled"], disabled), className);
  useEffect(function () {
    console.warn(DEPRECATED_TAG_MESSAGE);
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: customClassNames
  }, restProps), children);
};